/**
 * État 104 Generator Page
 * 
 * Page for generating État 104 (annual client statement)
 */

import { createFileRoute } from '@tanstack/react-router';
import { Etat104GeneratorComponent } from '@/components/compliance/Etat104Generator';

export const Route = createFileRoute('/apps/compliance/etat-104')({
  component: Etat104Page,
});

function Etat104Page() {
  return (
    <div className="container mx-auto py-8">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">État 104 - Liste des clients</h1>
        <p className="mt-2 text-gray-600 dark:text-gray-400">
          Générez votre état détaillé des clients pour la DGI
        </p>
      </div>

      <Etat104GeneratorComponent />
    </div>
  );
}
